/*
 * Where am I running? Derived purely from what the browser already knows.
 *
 * Everything here is public by construction (it comes out of the page URL), so
 * it is safe to show in the diagnostics panel and safe to return from a tool.
 * Never add anything sourced from `.env` — Parcel would inline it into the
 * public bundle.
 */

/**
 * @returns {{hostname: string, environment: string, workspace: string|null,
 *            runtimeNamespace: string|null, origin: string, secureContext: boolean,
 *            topLevel: boolean, originAgentCluster: boolean|null}}
 */
export function describeEnvironment (loc = window.location) {
  const hostname = loc.hostname
  let environment = 'unknown'
  let workspace = null
  let runtimeNamespace = null

  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local')) {
    environment = 'local development'
  } else if (hostname.endsWith('.adobeio-static.net') || hostname.endsWith('.dev.runtime.adobe.io')) {
    environment = 'Adobe App Builder'
    runtimeNamespace = hostname.split('.')[0]
    workspace = runtimeNamespace.endsWith('-stage') ? 'Stage' : 'Production'
  } else if (hostname.endsWith('.adobe.com')) {
    environment = 'Adobe Experience Cloud shell'
  }

  return {
    hostname,
    origin: loc.origin,
    environment,
    workspace,
    runtimeNamespace,
    secureContext: typeof window !== 'undefined' ? window.isSecureContext === true : false,
    topLevel: typeof window !== 'undefined' ? window.top === window.self : true,
    originAgentCluster: typeof window !== 'undefined' && 'originAgentCluster' in window
      ? window.originAgentCluster
      : null
  }
}
